module.exports = __webpack_public_path__ + "img/casino.03fd1e5e.png";